import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';
import { SiteTab } from 'views/order-feed/features/my-supply-plan/types/site-tab.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
  aSites: number;
  iSites: number;
};

const SitesSubTabs: React.FC<Props> = ({ aSites, iSites }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan';

  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.sitesLabel` }, { value: aSites }),
          value: SiteTab.ACTIVE,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.inactiveSitesLabel` }, { value: iSites }),
          value: SiteTab.INACTIVE,
        },
      ]}
    />
  );
};

export default React.memo(SitesSubTabs);
